export default function ChartShell({ title, subtitle, children, className = "" }) {
  return (
    <div
      className={`min-w-0 rounded-2xl border border-slate-200/90 bg-white p-5 shadow-[0_1px_3px_rgba(15,23,42,0.06),0_8px_24px_rgba(15,23,42,0.06)] transition-shadow duration-300 hover:shadow-[0_4px_12px_rgba(15,23,42,0.08)] ${className}`}
    >
      <div className="mb-4">
        <h3 className="text-sm font-semibold tracking-tight text-slate-900">{title}</h3>
        {subtitle ? <p className="mt-1 text-xs leading-relaxed text-slate-500">{subtitle}</p> : null}
      </div>
      <div className="min-w-0 w-full">{children}</div>
    </div>
  );
}
